module.exports = __webpack_public_path__ + "img/img_takashi.ca2d2dc8.png";